import * as types from '../constants/auth';
import api from '../api';
import store from 'store';
import jwtDecode from 'jwt-decode';

export const loginStart = () => {
  return {
    type: types.LOGIN_START
  };
};

export const loginSuccess = (payload) => {
  if (payload.token) {
    const { access_token } = jwtDecode(payload.token)[0];
    store.set('token', access_token);
  }

  return {
    type: types.LOGIN_SUCCESS,
    payload
  };
};

export const loginFailure = (error) => {
  return {
    type: types.LOGIN_FAILURE,
    error
  };
};

export const login = (payload, cb) => (dispatch) => {
  const { login, password } = payload;

  dispatch(loginStart());

  api.get(`api.php?cmd=auth&login=${login}&password=${password}`)
    .then(({ data }) => {
      const { token, status: { code, message } } = data;
      const payload = {
        token
      };

      code === 200 ? dispatch(loginSuccess(payload)) : dispatch(loginFailure(message));

      if (cb) {
        cb();
      }
    })
    .catch(err => {
      dispatch(loginFailure(err));
    });
};

export const signupStart = () => {
  return {
    type: types.SIGNUP_START
  };
};

export const signupSuccess = (payload) => (dispatch) => {
  if (payload.login) {
    store.set('login', payload.login);
  }

  dispatch({
    type: types.SIGNUP_SUCCESS,
    payload: {
      login: payload.login,
    }
  });
  dispatch(login(payload));
};

export const signupFailure = (error) => {
  return {
    type: types.SIGNUP_FAILURE,
    error
  };
};

export const signup = (payload, cb) => (dispatch) => {
  const {
    login,
    password,
    email
  } = payload;

  dispatch(signupStart());

  api.get(`api.php?cmd=signUp&login=${login}&password=${password}&email=${email}`)
    .then(({ data }) => {
      const { code, message } = data.status;
      const payload = {
        login,
        password,
        message,
      };

      code === 200 ? dispatch(signupSuccess(payload)) : dispatch(signupFailure(message));

      if (cb) {
        cb();
      }
    })
    .catch(err => {
      dispatch(signupFailure(err));
    });
};

export const confirmStart = () => {
  return {
    type: types.CONFIRM_START
  };
};

export const confirmSuccess = (payload) => {
  if (payload) {
    const { access_token } = jwtDecode(payload.token)[0];
    store.set('token', access_token);
  }

  return {
    type: types.CONFIRM_SUCCESS,
    payload: {
      token: payload
    }
  };
};

export const confirmFailure = (error) => {
  return {
    type: types.CONFIRM_FAILURE,
    error
  };
};

export const confirm = (payload, cb) => (dispatch) => {
  const { token } = payload;
  dispatch(confirmStart());

  api.get(`api.php?cmd=approve&h=${token}`)
    .then(({ data }) => {
      const { code } = data.status;

      code === 200 ? dispatch(confirmSuccess(data.token)) : dispatch(confirmFailure(data.status.message));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(confirmFailure(err));
    });
};

export const resetPasswordStart = () => {
  return {
    type: types.RESET_PASSWORD_START
  };
};

export const resetPasswordSuccess = (payload) => {
  return {
    type: types.RESET_PASSWORD_SUCCESS,
    payload
  };
};

export const resetPasswordFailure = (error) => {
  return {
    type: types.RESET_PASSWORD_FAILURE,
    error
  };
};

export const resetPassword = (payload, cb) => (dispatch) => {
  const { email } = payload;

  dispatch(resetPasswordStart());

  api.post(`api.php?cmd=reset&email=${email}`)
    .then(({ data }) => {
      const { status: { code, message } } = data;

      code === 200 ? dispatch(resetPasswordSuccess(message)) : dispatch(resetPasswordFailure(message))

      if (cb) {
        cb();
      }
    })
    .catch(err => {
      dispatch(resetPasswordFailure(err));
    });
};

export const logout = () => (dispatch) => {
  store.clearAll();
  dispatch({
    type: types.LOGOUT
  });
};
